export default {"src":"/_next/static/media/Notify.432a5183.svg","height":32,"width":32};